import iMic from "../../assets/images/100-mic-gray-opacity.svg";
import avatar1 from "../../assets/images/avatar1.png";
import userImg from "../../assets/images/user1.png";

const SingleVideoParticipant = ({ index }) => (
  <div className={`single-video-participant ${index === 1 && "talking"}`}>
    <div className="participant-controller">
      <img src={iMic} width={24} height={24} className="pointer m-t-16 m-r-16" alt="" />
    </div>
    {index === 3 && (
      <div className="w-100p h-100p br-8 flex-col align-items-center justify-content-center">
        <img src={avatar1} width={80} height={80} className="participant-small-avatar" alt="" />
      </div>
    )}
    {index !== 3 && <img src={userImg} className="w-100p h-100p br-8" alt="" />}
    <div className="participant-name"> David</div>
  </div>
);

export default SingleVideoParticipant;
